define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll', 'jump',
        'underscore', 'lightbox', 'slider', 'load-more'],
    function ($, transit, modernizr, container, preloader, router, scroll, jumpFactory,
              _, lightboxFactory, sliderFactory, loadMoreFactory) {

        var module = (function () {

            var name = 'module-tv-layout-gallery';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            const jump = jumpFactory.create();
            const lightbox = lightboxFactory.create();
            let loadMore = loadMoreFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {
                loadedItems: new Map()
            };

            model.methods = {
                getLightboxGalleryItems: function (id, slug) {
                    if(model.privateVars.loadedItems.has(slug)) {
                        let data = model.privateVars.loadedItems.get(slug);
                        data.selected_image_id = id;
                        pubSub.publish('view/actionGetLightboxItems', data);
                    } else {
                        $.ajax({
                            url: model.publicVars.ajaxGetGalleryEndpoint + '/' + slug,
                            type: 'GET',
                            data: {}
                        }).done(function (data) {
                            model.privateVars.loadedItems.set(slug, data);
                            data.selected_image_id = id;
                            pubSub.publish('view/actionGetLightboxItems', data);
                        });
                    }
                }
            };

            /* view */

            view.publicVars = {};

            view.privateVars = {
                anim: 0,
                lightboxAnim: 0,

                currentGallery: {
                    id: null,
                    slug: null
                },

                currentGalleryLightboxImages: {
                    items: {},
                    count: 0
                },

                currentGalleryLightboxImage: null,

                isSliderInit: false,
                loadingSliderItemsState: false,
                loadingSliderItemsNewId: null,

                gallerySize: {
                    width: 932,
                    height: 611
                },

                lightboxTouch: {
                    lightboxTouchStart: 0,
                    lightboxTouchDiff: 0,
                    lightboxTouchStartY: 0,
                    lightboxTouchDiffY: 0,

                    lightboxSlideStarted: false,
                    lightboxEndTrans: false,
                }
            };

            view.startup = function () {
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.tvLayoutGalleryHeaderCls, 'animate__slideInDown', 'tv-layout-gallery', {});

                $(view.publicVars.cssId.anim.tvLayoutGalleryImageBoxWrapperCls).each(function (key, item) {
                    const id = container.getData($(item)[0], 'id');
                    scroll.registerAnimatedElement('#' + view.publicVars.cssId.anim.tvLayoutGalleryImageBoxWrapperCls .substr(1)
                        + view.publicVars.currentGallery.id + '-' + id, 'animate__zoomIn', 'tv-layout-gallery', {});
                });

                if($(view.publicVars.cssId.anim.tvLayoutGalleryLoadMoreCls).length > 0) {
                    scroll.registerAnimatedElement(view.publicVars.cssId.anim.tvLayoutGalleryLoadMoreCls, 'animate__zoomIn', 'tv-layout-gallery', {});
                }


                view.privateVars.currentGallery.id = view.publicVars.currentGallery.id;
                view.privateVars.currentGallery.slug = view.publicVars.currentGallery.slug;

                lightbox.init(view.publicVars.lightboxSetup);
                lightbox.setCloseCallback(view.methods.lightbox.onLightboxClose);

                preloader.setPreloadBulk(name, view.publicVars.preloadTab);

                loadMore.init(view.publicVars.loadMoreSetup);
                loadMore.setAdditionalParamCallback(view.methods.loadMore.getCurrentGallerySlug);
                loadMore.setSuccessCallback(view.methods.loadMore.loadMoreSuccessCallback);
            };

            view.bind = function () {
                $(view.publicVars.cssId.tvLayoutGalleryInnerCls).on('click', view.publicVars.cssId.tvLayoutGalleryImageBoxWrapperCls,function () {

                    view.privateVars.lightboxAnim = 1;

                    const id = container.getData($(this)[0], 'id');
                    const width = container.getData($(this)[0], 'width');
                    const height = container.getData($(this)[0], 'height');

                    $('html').addClass(view.publicVars.cssId.galleryLightboxOpenCls.substr(1));
                    $(view.publicVars.cssId.tvLayoutGalleryLightboxLoaderWrapperCls).css({ display: 'block'});
                    $(view.publicVars.cssId.tvLayoutGalleryLightboxCls).addClass(view.publicVars.cssId.isLoadingCls.substr(1));

                    view.methods.lightbox.calculateLightboxSize(width, height);

                    lightbox.showLayer(() => {
                        scroll.disableAll();
                        view.methods.lightbox.sliderShowInit(id);
                    });
                });

                $(view.publicVars.cssId.tvLayoutGalleryLightboxArrowLeftId).click(function () {
                    const newId = (view.privateVars.currentGalleryLightboxImage > 1)
                        ? (view.privateVars.currentGalleryLightboxImage - 1) : view.privateVars.currentGalleryLightboxImages.count;

                    if(!view.privateVars.lightboxAnim) {
                        view.privateVars.lightboxAnim = 1;
                        view.methods.lightbox.sliderShowInit(newId);
                    }
                });

                $(view.publicVars.cssId.tvLayoutGalleryLightboxArrowRightId).click(function () {
                    const newId = (view.privateVars.currentGalleryLightboxImage < view.privateVars.currentGalleryLightboxImages.count)
                        ? (view.privateVars.currentGalleryLightboxImage + 1) : 1;

                    if(!view.privateVars.lightboxAnim) {
                        view.privateVars.lightboxAnim = 1;
                        view.methods.lightbox.sliderShowInit(newId);
                    }
                });

                $(window).resize(() => {
                    if (lightbox.getStatus() === 1) {

                        let currentImage = {
                            'width': view.privateVars.gallerySize.width,
                            'height': view.privateVars.gallerySize.height
                        }

                        if(view.privateVars.currentGalleryLightboxImage) {
                            currentImage = view.privateVars.currentGalleryLightboxImages.items[view.privateVars.currentGalleryLightboxImage];
                        }

                        view.methods.lightbox.calculateLightboxSize(currentImage.width, currentImage.height);
                    }
                });

                $(window).on('orientationchange', () => {
                    if (lightbox.getStatus() === 1) {
                        let currentImage = {
                            'width': view.privateVars.gallerySize.width,
                            'height': view.privateVars.gallerySize.height
                        }

                        if(view.privateVars.currentGalleryLightboxImage) {
                            currentImage = view.privateVars.currentGalleryLightboxImages.items[view.privateVars.currentGalleryLightboxImage];
                        }

                        view.methods.lightbox.calculateLightboxSize(currentImage.width, currentImage.height);
                    }
                });
            };

            view.methods = {

                loadMore: {
                    getCurrentGallerySlug: () => {
                        return view.privateVars.currentGallery.slug
                    },

                    loadMoreSuccessCallback: (data, newCount) => {
                        if(data.current && data.current.images.length > 0) {
                            data.current.images.forEach(function (item) {
                                scroll.registerAnimatedElement('#' + view.publicVars.cssId.anim.tvLayoutGalleryImageBoxWrapperCls.substr(1)
                                    + data.current.id + '-' + item.id, 'animate__zoomIn', 'tv-layout-gallery', {});
                            });
                        }
                    }
                },

                lightbox: {
                    sliderShowInit: (id) => {

                        if(!view.privateVars.loadingSliderItemsState) {

                            view.privateVars.loadingSliderItemsNewId = null;

                            if (!view.privateVars.isSliderInit) {
                                view.privateVars.isSliderInit = true;
                                view.privateVars.loadingSliderItemsState = true;
                                // view.methods.lightbox.actionGetLightboxItems(id);
                                model.methods.getLightboxGalleryItems(id, view.privateVars.currentGallery.slug);
                            } else {
                                view.methods.lightbox.sliderShow(id);
                            }
                        } else {
                            view.privateVars.loadingSliderItemsNewId = id;
                        }

                    },

                    actionGetLightboxItems: (action, data) => {

                        let id = data.selected_image_id;

                        view.privateVars.loadingSliderItemsState = false;

                        if(view.privateVars.loadingSliderItemsNewId !== null) {
                            id = parseInt(view.privateVars.loadingSliderItemsNewId);
                            view.privateVars.loadingSliderItemsNewId = null;
                        }

                        data.current.images_all.forEach(function (item) {

                            view.privateVars.currentGalleryLightboxImages.items[item.id] = {
                                image: item.big,
                                id: item.id,
                                title: 'Gallery Image ' + id,
                                width: item.width,
                                height: item.height
                            }

                        });

                        view.privateVars.currentGalleryLightboxImages.count = data.current.count_all;

                        view.methods.lightbox.sliderShow(id);
                    },

                    sliderShow: (id) => {

                        let currentImage = view.privateVars.currentGalleryLightboxImages.items[id];
                        view.privateVars.currentGalleryLightboxImage = parseInt(id);

                        const lightboxSize = view.methods.lightbox.calculateLightboxSize(currentImage.width, currentImage.height);

                        $(view.publicVars.cssId.tvLayoutGalleryLightboxInnerAreaImgCls).css({ display: 'block', opacity: 0, scale: 1});

                        preloader.preloadSingleImage('slider-init', currentImage.image, () => {

                            $(view.publicVars.cssId.tvLayoutGalleryLightboxInnerAreaImgCls).attr('src', currentImage.image);

                            setTimeout(function () {
                                $(view.publicVars.cssId.tvLayoutGalleryLightboxCls).removeClass(view.publicVars.cssId.isLoadingCls.substr(1));

                                $(view.publicVars.cssId.tvLayoutGalleryLightboxInnerAreaImgCls).transit({ opacity: 1, scale: 1}, 300, function () {
                                    view.privateVars.lightboxAnim = 0;
                                });
                            }, 500)
                        });
                    },

                    calculateLightboxSize: (width, height) => {

                        const windowWidth = $(window).width();
                        const windowHeight = $(window).height();

                        const paddingTop = parseInt($(view.publicVars.cssId.tvLayoutGalleryLightboxAreaCls).css('padding-top'));
                        const paddingBottom = parseInt($(view.publicVars.cssId.tvLayoutGalleryLightboxAreaCls).css('padding-bottom'));
                        const paddingLeft = parseInt($(view.publicVars.cssId.tvLayoutGalleryLightboxAreaCls).css('padding-left'));
                        const paddingRight = parseInt($(view.publicVars.cssId.tvLayoutGalleryLightboxAreaCls).css('padding-right'));

                        const border = parseInt($(view.publicVars.cssId.tvLayoutGalleryLightboxAreaCls).css('border-width'));

                        const maxWidth = windowWidth - paddingLeft - paddingRight - border - border;
                        const maxHeight = windowHeight - paddingTop - paddingBottom - border - border;

                        // const maxWidth = windowWidth;
                        // const maxHeight = windowHeight;

                        let lightboxSize;

                        let adjustedWidth = view.privateVars.gallerySize.width;
                        let adjustedHeight = view.privateVars.gallerySize.height;

                        if (width !== '' && height !== '' && parseInt(width) > 400 && parseInt(height) > 400) {
                            adjustedWidth = parseInt(width);
                            adjustedHeight = parseInt(height);
                        }

                        //adjustedWidth = adjustedWidth + paddingLeft + paddingRight;
                        //adjustedHeight = adjustedHeight + paddingTop + paddingBottom;

                        lightboxSize = view.methods.lightbox.calculateSizeProportionForMaxValues(maxWidth, maxHeight,
                            adjustedWidth, adjustedHeight);

                        const newWidth = lightboxSize.width + paddingLeft + paddingRight + border + border;
                        const newHeight = lightboxSize.height + paddingTop + paddingBottom + border + border;

                        $(view.publicVars.cssId.tvLayoutGalleryLightboxAreaCls)
                            .css({width: newWidth + 'px', height: newHeight + 'px'});

                    },

                    calculateSizeProportionForMaxValues: (maxWidth, maxHeight, width, height) => {

                        if (width <= maxWidth && height <= maxHeight) {
                            return {width: width, height: height};
                        }

                        const widthHeightRatio = width / height;
                        const heightWidthRatio = height / width;

                        if (width > maxWidth) {

                            const widthDiff = width - maxWidth;
                            width = maxWidth;
                            height = height - (heightWidthRatio * widthDiff);
                        }

                        if (height > maxHeight) {
                            const heightDiff = height - maxHeight;
                            height = maxHeight;

                            width = width - (widthHeightRatio * heightDiff);
                        }

                        return {width: width, height: height};
                    },

                    onLightboxClose: () => {
                        scroll.enableAll();
                        $('html').removeClass(view.publicVars.cssId.galleryLightboxOpenCls.substr(1));
                        $(view.publicVars.cssId.tvLayoutGalleryGalleryLightboxCls).addClass(view.publicVars.cssId.isLoadingCls.substr(1));
                        $(view.publicVars.cssId.tvLayoutGalleryLightboxLoaderWrapperCls).css({ display: 'block'});

                        $(view.publicVars.cssId.tvLayoutGalleryLightboxInnerAreaImgCls).css({ display: 'none'});

                        view.privateVars.currentGalleryLightboxImage = null;
                    },
                },

                setCallbacks: (callbacks) => {
                    view.privateVars.callbacks = callbacks;
                }
            };

            /* custom events */
            pubSub.subscribe('view/actionGetLightboxItems', view.methods.lightbox.actionGetLightboxItems);
            // pubSub.subscribe('view/updateCharacterContent', view.methods.updateCharacterContent);

            //pubSub.subscribe('view/updateSuccessLikes', view.methods.updateSuccessLikes);
            //pubSub.subscribe('view/updateSuccessViews', view.methods.updateSuccessViews);

            /* public methods */
            return {
                init: function (options, callbacks) {
                    view.methods.setCallbacks(callbacks);
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();


        return module;

    });